import { find, omitBy, isNil, map, isEmpty } from 'lodash';
import moment from 'moment';

const response = (message: any) => {

    let accountType = message.sender.includes('users_dem') ? 'DEM' : 'P2U';

    const getTimeValue = (obj) => {
        var endDate = moment(obj.createdAt);
        var startDate = moment(new Date());
        let diff = startDate.diff(endDate, 'days');
        if (diff) {
            return diff + ' days ago';
        } else {
            return moment(obj.createdAt).format('hh:mm A');
        }
    }

    return omitBy({
        ...message,
        displayOption: message.displayOption ? message.displayOption : 'TEXT',
        //  direction: message.sender.includes('users_dem') ? 'outgoing' : 'incoming',
        direction: accountType == process.env.ACCOUNT_TYPE ? 'outgoing' : 'incoming',
        time: getTimeValue(message)
    }, isNil)
}

export default response;
